<div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">UPSI Recipient</h5>
      <button aria-label="Close" class="close" type="button" (click)="activeModal.dismiss('close')">
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
        
        <!-- <pre>{{ BothCombArrayUser | json }}</pre> -->
        
      <div class="row">
        <span style="color: red; text-align: center;" *ngIf="errorMessage">Please select atleast one recipient user from
          list.</span>
        <div class="col-sm-12">     
          <table datatable [dtOptions]="dtOptionsForUPSI" [dtTrigger]="dtTriggerForUPSI" id="recipientNonGovevaUserList" class="table table-hover compact cell-border nowrap stripe">
              <thead>
                  <tr>
                    <th><div class="md-checkbox">
                        <input type="checkbox" name="internalUser" id="selectedUserAll" [(ngModel)]="selectUPSIUserAll" (click)="selectAll($event)">
                        <label for="selectedUserAll">&nbsp;</label>
                      </div></th>
                    <th>Name</th>
                    <th>Designation</th>
                    <th>Email Id</th>
                    <th>Recipient Code</th>
                    <th>Unique Identifier Type</th>
                    <th>User Type</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let UPSIUser of BothCombArrayUser; let count=index">
                    <td>
                        <div class="md-checkbox">
                          <input type="checkbox" name="internalUser" id="selectedUPSIUser{{count}}" [(ngModel)]="UPSIUser.IsSelected" (click)="multiCheck($event, UPSIUser._id, count)">
                          <label for="selectedUPSIUser{{count}}">&nbsp;</label>
                        </div>
                    </td>
                    <td>
                      {{ UPSIUser.Name }}
                    </td>
                    <td>
                      {{ UPSIUser.Designation }}
                    </td>
                    <td>
                      {{ UPSIUser.email_id }}
                    </td>
                    <td>
                      {{ UPSIUser.EmpCode }}
                    </td>
                    <td>
                      {{ UPSIUser.Unique_Identifier_Type }}
                    </td>
                    <td> {{ (UPSIUser.UserType == 'govevaUser')?'Goveva User':'UPSI User'}}</td>
                  </tr>
                </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-sm btn-danger" (click)="save()">
        <i class="fa fa-check"></i>&nbsp;Save</button>
      <button type="button" class="btn btn-sm btn-primary" (click)="activeModal.dismiss('')">
        <i class="fa fa-times"></i>&nbsp;Cancel</button>
    </div>
  </div>